import {Button, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger} from "@nextui-org/react";
import {FileEarmarkPersonFill} from "react-bootstrap-icons";
import { ContractEntry } from "../interfaces/Contracts.interface";

interface AttachmentDropdownProps {
    item: ContractEntry;
    setFileView: (url: string) => void
}

export const AttachmentDropdown:React.FC<AttachmentDropdownProps> = ({item, setFileView}) => {
    const disabled = (
                        // Archivos de activo
                        !item.pdf_factura_file &&
                        !item.asset_file_seguro &&
                        !item.asset_file_tarjeta_circulacion &&
                        !item.asset_file_primera_verificacion &&

                        // Archivos de contrato
                        !item.carta_promesa_file &&
                        !item.orden_requisicion_file &&
                        !item.contrato_file &&
                        !item.deposito_garantia_file &&
                        !item.deposito_garantia_usuario_file &&
                        !item.pagare_file
                    );

    const fileEntries = [
        {
            url: item.carta_promesa_file,
            label: "PDF Carta Promesa"
        },
        {
            url: item.pdf_factura_file,
            label: "PDF Factura"
        },
        {
            url: item.orden_requisicion_file,
            label: "PDF Orden Requisición"
        },
        {
            url: item.asset_file_seguro,
            label: "PDF Póliza seguro"
        },
        {
            url: item.asset_file_primera_verificacion,
            label: "PDF Talón verificación"
        },
        {
            url: item.asset_file_tarjeta_circulacion,
            label: "PDF Tarjeta Circulación"
        },
        {
            url: item.contrato_file,
            label: "PDF Contrato"
        },
        {
            url: item.deposito_garantia_file,
            label: "PDF Depósito en Garantía"
        },
        {
            url: item.deposito_garantia_usuario_file,
            label: "PDF Depósito en Garantía Usuario"
        },
        {
            url: item.pagare_file,
            label: "PDF Pagaré"
        }
    ];

    const fileViewSelected = (url: string|null) => {
        if(url)
        {
            setFileView(url)
        }
    }

    return (
        <Dropdown backdrop="blur">
            <DropdownTrigger>
                <Button isDisabled={disabled} color="secondary" variant={disabled ? "flat" : "solid"} size="md">
                    <FileEarmarkPersonFill size={20}/> Ver
                </Button>
            </DropdownTrigger>

            <DropdownMenu variant="faded" aria-label="Static Actions">
                {fileEntries.map((file, index) => 
                    file.url ? <DropdownItem key={index} onPress={() => fileViewSelected(file.url)}>{file.label}</DropdownItem> : <></>
                )}
            </DropdownMenu>
        </Dropdown>
    );
};